<template>
  <!-- section class="is-pc" -->
  <section>
      <ul>
        <li class="is-pctbOnly">
          <img src="/images/parts_01.jpg">
        </li>
        <li>
          <div>
            <p class="en">Feature</p>
            <p class="ja">浴室パーツ</p>
            <div class="btn">
              <app-button path="/feature" name="詳しくみる" />
            </div>
          </div>
        </li>
        <li>
          <img src="/images/parts_02.jpg" class="is-pctbOnly">
          <img src="/images/parts_02_sp.jpg" class="is-spOnly">
        </li>
        <li class="is-pctbOnly">
          <img src="/images/parts_03.jpg">
        </li>
      </ul>
  </section>
</template>

<script>
import AppButton from '@/components/AppButton.vue'

export default {
  name: 'SlideMaterial',
  components: {
    AppButton
  }
}
</script>

<style scoped lang="scss">
ul {
  display: flex;

    @include mq(sp) {
      flex-direction: column;
    }
  > li {
    width: calc(100% / 4);
    background: $colorLightGray;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    div {
      max-width: 236px;
      width: 100%;
    }

    @include mq(sp) {
      width: auto;
      padding: 32px 0 0 0;
    }
  }

  img {
    width: 100%;
  }

  .en {
    font-family: $bellFont;
    font-size: 36px;
    margin-bottom: 16px;
  }

  .ja {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .btn {
    width: 100%;
  }
}
</style>